import { useIM, MessageIncomingEvent, MessageTypedEvent , MessageCallReceived } from '@wui/im'
import { defineStore } from 'pinia'
import { ref } from 'vue'

import { TypingSubscribers } from './'

// ключ - id пользователя
type Timeout = Map<string, NodeJS.Timeout>

const INTERVAL = 3000

const timeoutIds = new Map<string, Timeout>()

export const useTypingStore = defineStore('typing', () => {
  const typingsByPServed = ref<Map<string, TypingSubscribers>>(new Map())

  const addTyping = (pServed: string, subscriberId: string, timestamp: number) => {
    if (!pServed || !subscriberId) {
      return
    }

    if (!typingsByPServed.value.get(pServed)) {
      typingsByPServed.value.set(pServed, new Map([[subscriberId, timestamp]]))
    } else {
      const typing = typingsByPServed.value.get(pServed)
      if (typing) {
        typing.set(subscriberId, timestamp)
      }
    }

    let pServedTimeouts = timeoutIds.get(pServed)
    const subscriberTimeoutId = pServedTimeouts?.get(subscriberId)

    if (subscriberTimeoutId) {
      clearTimeout(subscriberTimeoutId)
    }

    const timeoutId = setTimeout(() => {
      removeTyping(pServed, subscriberId)
    }, INTERVAL)

    if (!pServedTimeouts) {
      timeoutIds.set(pServed, new Map())
    }

    pServedTimeouts = timeoutIds.get(pServed)
    pServedTimeouts?.set(subscriberId, timeoutId)
  }

  const removeTyping = (pServed: string, subscriberId: string) => {
    const typing = typingsByPServed.value.get(pServed)

    if (typing) {
      typing.delete(subscriberId)
    }

    const pServedTimeouts = timeoutIds.get(pServed)
    if (pServedTimeouts?.has(subscriberId)) {
      clearTimeout(pServedTimeouts.get(subscriberId))

      pServedTimeouts.delete(subscriberId)
    }
  }

  const { onTextTyping, onMessage } = useIM()

  onTextTyping((event: MessageTypedEvent) => {
    addTyping(event.executorRoom, event.executorUser, event.timestamp)
  })

  onMessage((event: MessageIncomingEvent | MessageCallReceived) => {
    if (event.type === 'IncomingMessageEvent') {
      const subscriberId = event.executor
      removeTyping(event.pServed, subscriberId)
    }
  })

  return {
    typingsByPServed,
    addTyping,
    removeTyping,
  }
})
